<template>
  <q-page>
    <q-table title="Orders" 
             :columns="ordersColumns" 
             :data="orders" flat 
             :pagination.sync="pagination"
             :filter="filter" 
             binary-state-sort>
      <template v-slot:top>
        <q-space />
        <q-input dense debounce="300" color="primary" v-model="filter">
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
      </template>             
      <template v-slot:body-cell-orderNumber="props">
        <q-td :props="props">
          <router-link v-if="props.row.orderType==='Stock'" :to="`/account/orders/stock/${props.row.id}`">{{props.row.orderNumber}}</router-link>
          <router-link v-if="props.row.orderType==='Container'" :to="`/account/orders/container/${props.row.id}`">{{props.row.orderNumber}}</router-link>
          <router-link v-if="props.row.orderType==='Retail'" :to="`/account/orders/retail/${props.row.id}`">{{props.row.orderNumber}}</router-link>
        </q-td>
      </template>
    </q-table>
  </q-page>
</template>

<script>
import moment from 'moment'
import gql from 'graphql-tag'
import { formatCurrency, formatDateTime } from '../../util/string'

export default {
  name: 'PageAccountOrders',
  apollo: {
    stockOrders () {
      return {
        query: gql`
          query {
            accountOrders {
              id
              orderNumber
              name
              notes
              createdAt
              totalCost
              placed
              items {
                id,
                skuId,
                sku {
                  id
                  options
                  price
                  product {
                    id
                    name
                    attributes
                    images {
                      url
                      name
                    }
                    urlSlug
                  }
                }
                qty
                notes
              }
            }
          }
        `,
        update: data => data.accountOrders,
        fetchPolicy: 'network-only'
      }
    },
    retailOrders () {
      return {
        query: gql`
          query {
            accountRetailOrders {
              id
              orderNumber
              name
              notes
              createdAt
              totalCost
              placed
              items {
                id,
                skuId,
                sku {
                  id
                  options
                  retailPrice
                  product {
                    id
                    name
                    attributes
                    images {
                      url
                      name
                    }
                    urlSlug
                  }
                }
                qty
                notes
              }
            }
          }
        `,
        update: data => data.accountRetailOrders,
        fetchPolicy: 'network-only'
      }
    },
    containerOrders () {
      return {
        query: gql`
          query {
            accountContainerOrders {
              id
              orderNumber
              groupOrder {
                id
                openDate
                closeDate
                name
              }
              name
              notes
              createdAt
              totalCost
              placed
              items {
                id,
                skuId,
                sku {
                  id
                  options
                  price
                  product {
                    id
                    name
                    attributes
                    images {
                      url
                      name
                    }
                    urlSlug
                  }
                }
                qty
                notes
              }
            }
          }
        `,
        update: data => data.accountContainerOrders,
        fetchPolicy: 'network-only'
      }
    }
  },
  computed: {
    orders () {
      return [
        ...(this.stockOrders || []).map(so => ({ ...so, orderType: 'Stock' })),
        ...(this.containerOrders || []).map(co => ({ ...co, orderType: 'Container' })),
        ...(this.retailOrders || []).map(co => ({ ...co, orderType: 'Retail' }))
      ]
    }
  },
  methods: {
    fromNow (t) {
      if (!t) return '-'
      return moment(t).fromNow()
    },
    formatDate (d) {
      if (!d) return '-'
      return moment(d).format('DD/MM/YY HH:mm')
    }
  },
  data () {
    return {
      pagination: {
        sortBy: 'datePlaced',
        descending: true,
        page: 1,
        rowsPerPage: 0
      },
      filter: '',
      ordersColumns: [
        { name: 'orderNumber', align: 'left', required: true, label: 'Order #', field: 'orderNumber', sortable: true },
        { name: 'orderType', align: 'left', required: true, label: 'Order Type', field: row => row.orderType, sortable: true },
        { name: 'name', align: 'left', required: true, label: 'Name', field: 'name', sortable: true },
        { name: 'totalCost', align: 'left', required: true, label: 'Value', field: row => Number(row.totalCost), sortable: true, format: formatCurrency },
        { name: 'datePlaced', align: 'left', required: true, label: 'Date Submitted', field: row => row.placed, sortable: true, format: formatDateTime }
      ]
    }
  },
  async updated () {
    this.$apollo.queries.stockOrders.refetch()
    this.$apollo.queries.containerOrders.refetch()
    this.$apollo.queries.retailOrders.refetch()
  }
}
</script>
